import React from "react";
import { Layout } from "@kursk/components/Layout/Layout";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import styles from "./LayoutByData.module.scss";

export const LayoutByData = ({ offerData }) => (
  <Layout showSubscribePopup={false}>
    <SeoMetaTitles page="publicAgreement"/>
    <div className={styles.wrapper}>
      <div className={styles.redactionDate}>{offerData.redactionDate}</div>
      <div className={styles.title}>{offerData.mainTitle}</div>
      {offerData.offers.map(({ subtitle, sections }, index) => (
        <div key={`offer_${index}`}>
          <div className={styles.subtitle}>{subtitle}</div>
          {sections.map(({ title, paragraphs }) => (
            <div key={`section_${index}`} className={styles.section}>
              <div className={styles.paragraphTitle}>{title}</div>
              {paragraphs.map((p, index) => (
                <p key={`pragraph_${index}`} className={styles.paragraph}>{p}</p>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  </Layout>
)
